<script setup>
import { ref, onMounted } from 'vue'
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import Form from "@bread/ui/Pages/Form"
import {useForm} from "@inertiajs/inertia-vue3"
import "vue-select/dist/vue-select.css"
import 'v-calendar/dist/style.css';
import { DatePicker } from 'v-calendar'
import moment from 'moment'

const props = defineProps({
  devices: {
    type: Array,
    required: true,
  }
})

const defaultSchedule = [
  {day: 'Maandag', active: true, time: moment().startOf('day').hour(5).toDate()},
  {day: 'Dinsdag', active: true, time: moment().startOf('day').hour(5).toDate()},
  {day: 'Woensdag', active: true, time: moment().startOf('day').hour(5).toDate()},
  {day: 'Donderdag', active: true, time: moment().startOf('day').hour(5).toDate()},
  {day: 'Vrijdag', active: true, time: moment().startOf('day').hour(5).toDate()},
  {day: 'Zaterdag', active: true, time: moment().startOf('day').hour(5).toDate()},
  {day: 'Zondag', active: true, time: moment().startOf('day').hour(5).toDate()},
]

const getDefaultSchedule = (id) => {
  defaultSchedule.forEach((item) => {
    item.id = id
  });
  return defaultSchedule
}

const form = useForm({
  schedule: props.devices[0].schedule.length ?
                    props.devices[0].schedule :
                    getDefaultSchedule(props.devices[0].id),
  device: props.devices[0].id
})

onMounted(() => {
})

const selectDevice = ($event) => {
  form.device = $event.target.value
  let device = props.devices.filter(d => d.id === parseInt($event.target.value))[0];
  form.schedule = device.schedule.length ?
    device.schedule :
    getDefaultSchedule(device.id)
}

const showSchedule = ref(false)

const submit = () => {
  form.post(route("admin.devices.schedule"))
  showSchedule.value = false
}

</script>

<template>
  <div class="flex justify-center items-center">
    <div
      class="bg-slate-600 select-none hover:bg-slate-700 cursor-pointer rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm"
      @click="showSchedule = true">
      Planning
    </div>
    <Teleport to="body">
      <TransitionRoot as="template" :show="showSchedule">
        <Dialog as="div" class="relative z-10" @close="showSchedule = false">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                           leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
          </TransitionChild>

          <div class="fixed z-10 inset-0 overflow-y-auto">
            <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <TransitionChild as="template" enter="ease-out duration-300"
                               enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                               enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                               leave-from="opacity-100 translate-y-0 sm:scale-100"
                               leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <DialogPanel
                  class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                  <form @submit.prevent="submit">
                    <div>
                      <div class="mt-3 text-center sm:mt-5">
                        <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                         Planning product update commando
                        </DialogTitle>
                      </div>
                      <table class="border-collapse table-auto w-full text-sm mt-5">
                        <tbody class="bg-white dark:bg-slate-800">
                          <tr v-for="day of form.schedule" :key="day.day">
                            <td>
                              <label :for="'toggle-'+day.day" class="inline-flex relative items-center cursor-pointer">
                                <input v-model="day.active" type="checkbox" :id="'toggle-'+day.day" class="sr-only peer">
                                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-2">{{day.day}}</span>
                              </label>
                            </td>
                            <td class="text-right">
                              <DatePicker mode="time" v-model="day.time" is24hr/>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <select
                        class="my-2 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                        @change="selectDevice"
                      >
                        <option
                          :value="device.id"
                          v-for="(device, key) in devices"
                        >
                          {{ device.node_name }}
                        </option>
                      </select>
                    </div>
                    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                      <button type="submit"
                              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
                      >
                        Submit
                      </button>
                      <button type="button"
                              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                              @click="showSchedule = false"
                              ref="cancelButtonRef">
                        Cancel
                      </button>
                    </div>
                  </form>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </TransitionRoot>
    </Teleport>
  </div>
</template>

<style>
 :root {
   --vs-dropdown-max-height: 200px;
 }
 .vc-time-date{
   display: none;
 }
</style>
